<section>
  <div class="head">
    @if (label != null) {
    <heading slim>{{ label }}</heading>
    }
    <div class="controls"><ng-content select="[controls]"></ng-content></div>
  </div>

  <ng-content></ng-content>
</section>
